export default __webpack_public_path__ + "static/media/activity.57143c45.svg";